module.exports = __webpack_public_path__ + "static/img/member22.6713d6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member22.jpg
// module id = t+ri
// module chunks = 0